module.exports = __webpack_public_path__ + "media/packs/images/details/updates-c680162d73b6c95bf716cef3661b08f9.svg";